// app/javascript/controllers/sales_expenses_chart.js
document.addEventListener("turbo:load", () => {
  const chartEl = document.querySelector("#sales-expenses-chart");
  if (chartEl && window.ApexCharts) {
    const params = new URLSearchParams(window.location.search);

    fetch(`/reports/sales_vs_expenses.json?${params.toString()}`)
      .then(response => response.json())
      .then(data => {
        // Format categories (periods)
        const categories = data.map(item =>
          new Date(item.date).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric"
          })
        );

        // Series data
        const expensesSeries = data.map(item => item.expenses);
        const salesSeries  = data.map(item => item.sales);

        const options = {
          series: [
            { name: "sales", data: salesSeries },
            { name: "Expenses", data: expensesSeries }
          ],
          chart: {
            type: "line",
            height: 350,
            toolbar: { show: false }
          },
          colors: ["#198754", "#dc3545"], // green for sales, red for expenses
          stroke: { curve: "smooth" },
          dataLabels: { enabled: false },
          xaxis: { categories: categories },
          tooltip: { x: { format: "dd MMM yyyy" } },
          legend: { position: "top" }
        };

        new ApexCharts(chartEl, options).render();
      })
      .catch(error => console.error("Error loading sales vs expenses chart:", error));
  }
});
